import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import BarberShopPage from "pages/BarberShopPage";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/">
          <BarberShopPage />
        </Route>
      </Switch>
    </Router>
  );
}
